<template>
  <div class="listmain ">
    <h1 class="firTitle">风速的控制</h1>

	  <highlight-code lang="javascript">
		  {
		  "header":{
			  "namespace":"Orion.Iot.Device.Control",
			  "name":"SetWindSpeed",
			  "messageId":"83a82001-3494-18ae-f4d9-691b1834f2df",
			  "payLoadVersion":1
		  },
		  "payload":{
			  "accessToken":"access token",
			  "deviceId":"abcde12345",
			  "deviceType":"fan",
			  "attribute":"windspeed",
			  "value":"1" ,
			  "extensions":{
			  	"extension1":"",
			  	"extension2":""
			  }
		  }
		  }
	  </highlight-code>
	  <p>
		  <span class="ql-author-7802039 ql-size-9">风扇类的风速对应值</span>
	  </p>

	  <table style="color:#000000;font-family:-apple-system, system-ui, &quot;font-size:14.6667px;">
		  <tbody>
		  <tr>
			  <td style="background-color:#666666;color:#FFFFFF;font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;text-align:center;">
				  风速值
			  </td>
			  <td style="background-color:#666666;color:#FFFFFF;font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;text-align:center;">
				  说明
			  </td>
		  </tr>
		  <tr>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;text-align:center;">
				  1
			  </td>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;text-align:center;">
				  对应风速 1档
			  </td>
		  </tr>
		  <tr>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;text-align:center;">
				  2
			  </td>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;text-align:center;">
				  对应风速 2档
			  </td>
		  </tr>
		  <tr>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;text-align:center;">
				  3
			  </td>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;text-align:center;">
				  对应风速 3档
			  </td>
		  </tr>
		  <tr>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;text-align:center;">
				  4
			  </td>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;text-align:center;">
				  对应风速 4档
			  </td>
		  </tr>
		  <tr>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;text-align:center;">
				  5
			  </td>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;text-align:center;">
				  对应风速 5档
			  </td>
		  </tr>  <tr>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;text-align:center;">
				  6
			  </td>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;text-align:center;">
				  对应风速 6档
			  </td>
		  </tr>  <tr>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;text-align:center;">
				  7
			  </td>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;text-align:center;">
				  对应风速 7档
			  </td>
		  </tr>
		  </tbody>
	  </table>
	  <p>
		  <span class="ql-author-7802039 ql-size-9">空调类的风速对应值</span>
	  </p>

	  <table style="color:#000000;font-family:-apple-system, system-ui, &quot;font-size:14.6667px;">
		  <tbody>
		  <tr>
			  <td style="background-color:#666666;color:#FFFFFF;font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  风速值
			  </td>
			  <td style="background-color:#666666;color:#FFFFFF;font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  说明
			  </td>
		  </tr>
		  <tr>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  auto
			  </td>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  自动风
			  </td>
		  </tr>
		  <tr>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  low
			  </td>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  低风
			  </td>
		  </tr>
		  <tr>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  medium
			  </td>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  中风
			  </td>
		  </tr>
		  <tr>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  high
			  </td>
			  <td style="font-size:9pt;font-family:-apple-system, BlinkMacSystemFont, &quot;vertical-align:top;">
				  高风
			  </td>
		  </tr>
		  </tbody>
	  </table>

	  <p>
		  <span class="ql-author-7802039 ql-size-9">正常响应</span>
	  </p>

	  <highlight-code lang="javascript">
		  {
		  "header":{
			  "namespace":"Orion.Iot.Device.Control",
			  "name":"SetWindSpeedResponse",
			  "messageId":"83a82001-3494-18ae-f4d9-691b1834f2df",
			  "payLoadVersion":1
		  },
		  "payload":{
		 	 "deviceId":"abcde12345"
		  }
		  }
	  </highlight-code>
	  <p>
		  <span class="ql-author-7802039 ql-size-9">风速设置最值(最大、最小)</span>
	  </p>
	  <p>
		  <span class="ql-author-7802039 ql-size-9">最大max最小min</span>
	  </p>
	  <highlight-code lang="javascript">
		  {
		  "header":{
			  "namespace":"Orion.Iot.Device.Control",
			  "name":"SetWindSpeed",
			  "messageId":"83a82001-3494-18ae-f4d9-691b1834f2df",
			  "payLoadVersion":1
		  },
		  "payload":{
			  "accessToken":"access token",
			  "deviceId":"abcde12345",
			  "deviceType":"fan",
			  "attribute":"windspeed",
			  "value":"max" ,
			  "extensions":{
			 	 "extension1":"",
			 	 "extension2":""
			  }
		  }
		  }
	  </highlight-code>
	  <p>
		  <span class="ql-author-7802039 ql-size-9">正常响应：</span>
	  </p>
	  <highlight-code lang="javascript">
		  {
		  "header":{
			  "namespace":"Orion.Iot.Device.Control",
			  "name":"SetWindSpeedResponse",
			  "messageId":"83a82001-3494-18ae-f4d9-691b1834f2df",
			  "payLoadVersion":1
		  },
		  "payload":{
			  "deviceId":"abcde12345"
		  }
		  }
	  </highlight-code>
	  <p>
		  <span class="ql-author-7802039 ql-size-9">风速的步长调整（默认步长为1）</span>
	  </p>
	  <p>
		  <span class="ql-author-7802039 ql-size-9">调大风速</span>
	  </p>
	  <highlight-code lang="javascript">
		  {
		  "header":{
			  "namespace":"Orion.Iot.Device.Control",
			  "name":"AdjustUpWindSpeed",
			  "messageId":"83a82001-3494-18ae-f4d9-691b1834f2df",
			  "payLoadVersion":1
		  },
		  "payload":{
			  "accessToken":"access token",
			  "deviceId":"abcde12345",
			  "deviceType":"fan",
			  "attribute":"windspeedStep",
			  "value":"1",
			  "extensions":{
			  	 "extension1":"",
			 	 "extension2":""
			  }
		  }
		  }
	  </highlight-code>
	  <p>
		  <span class="ql-author-7802039 ql-size-9">正常响应：</span>
	  </p>
	  <highlight-code lang="javascript">
		  {
		  "header":{
			  "namespace":"Orion.Iot.Device.Control",
			  "name":"AdjustUpWindSpeedResponse",
			  "messageId":"83a82001-3494-18ae-f4d9-691b1834f2df",
			  "payLoadVersion":1
		  },
		  "payload":{
			  "deviceId":"abcde12345"
		  }
		  ｝
	  </highlight-code>
	  <p>
		  <span class="ql-author-7802039 ql-size-9">调小风速</span>
	  </p>
	  <highlight-code lang="javascript">
		  {
		  "header":{
			  "namespace":"Orion.Iot.Device.Control",
			  "name":"AdjustDownWindSpeed",
			  "messageId":"83a82001-3494-18ae-f4d9-691b1834f2df",
			  "payLoadVersion":1
		  },
		  "payload":{
			  "accessToken":"access token",
			  "deviceId":"abcde12345",
			  "deviceType":"fan",
			  "attribute":"windspeedStep",
			  "value":"1" ,
			  "extensions":{
			  	"extension1":"",
			  	"extension2":""
			  }
		  }
		  }
	  </highlight-code>
	  <p>
		  <span class="ql-author-7802039 ql-size-9">正常响应:</span>
	  </p>
	  <highlight-code lang="javascript">
		  {
			  "header":{
			  "namespace":"Orion.Iot.Device.Control",
			  "name":"AdjustDownWindSpeedResponse",
			  "messageId":"83a82001-3494-18ae-f4d9-691b1834f2df",
			  "payLoadVersion":1
		  },
		  "payload":{
		 	 "deviceId":"abcde12345"
		  }
		  }
	  </highlight-code>
  </div>
</template>

<script>
export default {
  name: ""
};
</script>


<style rel="stylesheet/scss" lang="scss" scoped>
  h1,
  h2,
  h3,
  h4,
  h5 {
    padding: 0;
    margin: 0px;
    font-weight: normal;
  }

  ul,
  li {
    list-style: none;
  }

  .listmain {
    font-size: 14px;
    line-height: 26px;
    .firTitle {
      font-size: 20px;
      color: #1e4d79;
      margin-bottom: 30px;
    }
    .sedTitle {
      font-size: 16px;
      font-weight: bold;
      padding-bottom: 10px;
      border-bottom: 1px solid #f3f3f3;
      margin-bottom: 15px;
      margin-top: 50px;
      &.fir {
        margin-top: 0px;
      }
    }
    .thirdTitle {
      margin-top: 50px;
      font-weight: bold;
      line-height: 30px;
      font-size: 16px;
    }
    .codeTitle {
      font-weight: bold;
      line-height: 26px;
    }
    pre {
      margin-top: 20px;
    }
    img {
      margin: 30px 0;
      width: 100%;
    }
    table,
    table tr th,
    table tr td {
      border: 1px solid #000;
      text-align: center;
    }
    table {
      line-height: 30px;
      width: 100%;
      border-collapse: collapse;
    }
  }

  .el-submenu .el-menu-item {
    min-width: 190px;
    background: #f5f5f5;
  }

  .el-submenu {
    min-width: 190px;
    background: #f5f5f5;
  }

  img {
    margin-top: 30px;
    margin-bottom: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/components/tutor/smartHome/equipmentControl/Zn_sb_fs.vue